import {Box, List, ListItem} from '@chakra-ui/react'
import {LinkButton} from '_app/components'
import {CategoryTree, Maybe} from '_app/types/api'
import BreakpointsHelper from '../../helpers/BreakpointsHelper/BreakpointsHelper'
import Breadcrumbs from '../../components/atoms/Breadcrumbs/Brudcrumbs'
import React from 'react'
import {useRouter} from '../../_app/hooks/useRouter'
import URLHelper from '../../helpers/URLHelper/URLHelper'

interface Props {
    navigation: any;
    category: CategoryTree;
}

export const CategoriesMenu = ({navigation, category}: Props) => {
    const { locale } = useRouter()
    return (
        <Box
            as="aside"
            flexBasis={BreakpointsHelper.isMobile() ? '100%' : '25%'}
            display={{ base: 'flex', lg: 'block' }}
        >
            <Breadcrumbs category={category}/>
            {
                !BreakpointsHelper.isMobile() && (
                    <Box top={180}>
                        <a
                            href={URLHelper.createURL({ href: `/${locale}/${navigation?.mainUrl}`, locale })}
                            style={{
                                fontSize: '1rem',
                                fontWeight: 300,
                                marginBottom: '16px',
                                display: 'inline-block',
                            }}
                            title={navigation?.title || ''}
                        >
                            {navigation?.title || ''}
                        </a>
                        <List>
                            {navigation?.items?.map((childCategory: Maybe<Partial<CategoryTree>>) => {
                                if (childCategory?.include_in_menu === 0) return null
                                return (
                                    <ListItem key={childCategory?.url_path} mb={4} ml={4}>
                                        <a
                                            href={URLHelper.createURL({ href: `/${locale}/${childCategory?.url_path}`, locale })}
                                            title={childCategory?.name || ''}
                                            style={{
                                                fontSize: '1rem',
                                                fontWeight: childCategory?.url_path === category?.url_path ? 500 : 300,
                                            }}
                                        >
                                            {childCategory?.name}
                                        </a>
                                    </ListItem>
                                )
                            })}
                        </List>
                    </Box>
                )
            }
        </Box>
    )
}
